import React from 'react';
import { ModalDialog } from '../../utils/ModalDialog';
import { LoadingScreen } from '../../LoadingScreen';
import { Chat } from 'stream-chat-react';
import { ChatSidebar } from './ChatSidebar';
import { useStreamChatContext } from '~/react_context/StreamChatContext';
import CreateChannelForm from './CreateChannelForm';
import { FAIcon } from '~/components/utils/FAIcons';
import { ChannelContainer } from './ChannelContainer';

import 'stream-chat-react/dist/css/v2/index.css';
import AddUsersToChannelForm from './AddUsersToChannelForm';
import EditChannelForm from './EditChannelForm';
import CreateDMForm from './CreateDMForm';

export default function CompanyChatModal({ onClose }: { onClose: () => void }) {
	const { chatOverlay, streamChatClient } = useStreamChatContext();

	return (
		<ModalDialog dialogOpen={true} maxW="max-w-[90vw]" panelContainerClass="h-[90vh] str-chat" closeFn={onClose}>
			{!streamChatClient && <LoadingScreen />}
			{streamChatClient && (
				// `Chat` is a provider for `ChatContext`, though isn't named like it
				<Chat client={streamChatClient}>
					<div className="flex items-stretch gap-4 divide-x h-full">
						<ChatSidebar />
						<div className="grow pl-4 pr-6">
							{chatOverlay === 'CREATE_CHANNEL' ? (
								<CreateChannelForm />
							) : chatOverlay === 'CREATE_DIRECT_MESSAGE' ? (
								<CreateDMForm />
							) : chatOverlay === 'ADD_USERS_TO_CHANNEL' ? (
								<AddUsersToChannelForm />
							) : chatOverlay === 'EDIT_CHANNEL' ? (
								<EditChannelForm />
							) : (
								<ChannelContainer />
							)}
						</div>
					</div>
				</Chat>
			)}
			<button className="absolute top-3 right-4" type="button" onClick={onClose}>
				<FAIcon icon="circle-xmark" className="text-gray-600 text-xl" />
			</button>
		</ModalDialog>
	);
}
